import { Card, CardContent } from '../ui/card';
import { CreditCard, CheckCircle, AlertCircle } from 'lucide-react';

const MerchantTransactionsTab = ({ payments }) => {
  if (payments.length === 0) {
    return (
      <div className="space-y-6 mt-6">
        <h2 className="text-xl font-heading font-semibold">Recent Transactions</h2>
        <Card className="text-center py-12">
          <CardContent>
            <CreditCard className="w-12 h-12 mx-auto text-muted-foreground mb-4" />
            <p className="text-muted-foreground">No transactions yet</p>
          </CardContent>
        </Card>
      </div>
    );
  }

  return (
    <div className="space-y-6 mt-6">
      <h2 className="text-xl font-heading font-semibold">Recent Transactions</h2>
      <div className="space-y-3">
        {payments.map((payment) => (
          <Card key={payment.id} data-testid={`transaction-${payment.id}`}>
            <CardContent className="py-4">
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-4">
                  <div className={`p-2 rounded-lg ${
                    payment.status === 'completed' ? 'bg-emerald-500/10' : 'bg-orange-500/10'
                  }`}>
                    {payment.status === 'completed' ? (
                      <CheckCircle className="w-5 h-5 text-emerald-600" />
                    ) : (
                      <AlertCircle className="w-5 h-5 text-orange-600" />
                    )}
                  </div>
                  <div>
                    <p className="font-medium">{payment.payer_email || 'Anonymous'}</p>
                    <p className="text-sm text-muted-foreground">
                      {new Date(payment.created_at).toLocaleDateString()}
                    </p>
                  </div>
                </div>
                <div className="text-right">
                  <p className="font-bold text-lg">${payment.amount.toFixed(2)}</p>
                  <p className="text-xs text-muted-foreground">
                    Fee: ${payment.fee.toFixed(2)}
                  </p>
                </div>
              </div>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
};

export default MerchantTransactionsTab;
